// src/util/TrendingCalculator.js
class TrendingCalculator {
    static calculateImageTrending(purchases, currentTime) {
        return purchases.reduce((total, purchase) => {
            const timeMinutes = (currentTime - purchase.paidOn) / (60 * 1000);
            return total + (purchase.amount * 1000) / (timeMinutes + 1);
        }, 0);
    }

    static calculateCommentTrending(reactions, currentTime) {
        if (!reactions) {
            return 0;
        }
        return reactions.reduce((total, reaction) => {
            const timeMinutes = (currentTime - reaction.reactedOn) / (60 * 1000);
            return total + (reaction.price * 1000) / (timeMinutes + 1);
        }, 0);
    }
}

export default TrendingCalculator;